import { Box, TextButton, Button, Divider } from '@wix/design-system';
import s from './SuggestionsWidget.module.scss';
import React from 'react';
export const SuggestionsChatWidget = _ref => {
  let {
    data: {
      suggestions
    },
    context: {
      send,
      onWidgetAction
    }

    // essentials: { httpClient },
  } = _ref;
  // Here you can use httpClient
  const handleWidgetAction = (action, value) => {
    if (onWidgetAction) {
      onWidgetAction(SUGGESTIONS_WIDGET, {
        action,
        value
      });
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    className: s.container
  }, suggestions.map(suggestion => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 2
  }, /*#__PURE__*/React.createElement(TextButton, {
    key: suggestion.name + '_text',
    skin: "light",
    underline: "none",
    onClick: () => {
      handleWidgetAction('pick_option', suggestion.name);
      send(suggestion.message);
    },
    className: s.suggestion
  }, suggestion.name), /*#__PURE__*/React.createElement(Button, {
    key: suggestion.name + '_button',
    size: "tiny",
    priority: "secondary",
    skin: "standard",
    onClick: () => {
      handleWidgetAction('pick_option', suggestion.name);
      send(suggestion.message);
    },
    className: s.action
  }, "Get it")), /*#__PURE__*/React.createElement(Divider, null))), /*#__PURE__*/React.createElement(TextButton, {
    onClick: () => {
      handleWidgetAction('suggest_more');
      send('Suggest more domains please');
    },
    className: s.more,
    skin: "dark"
  }, "Suggest More"));
};
export const SUGGESTIONS_WIDGET = 'SUGGESTIONS_WIDGET';

/*
MESSAGE:
<<{"widget": "SUGGESTIONS_WIDGET", "data": {"suggestions": [
      { "name": "mydomain1.com", "message": "mydomain1.com" },
          { "name": "mydomain2.com", "message": "mydomain2.com" },
          { "name": "mydomain3.com", "message": "mydomain3.com" }
        ]}}>>
*/
//# sourceMappingURL=SuggestionsWidget.js.map